document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.product-tab-link');
    const contents = document.querySelectorAll('.production-tab-link-content');

    // No slider initialization - removed slick slider functionality
    // The product grid is now a simple scrollable layout

    tabs.forEach(tab => {
        tab.addEventListener('click', function(e) {
            e.preventDefault();

            // 1. Remove active class from all tabs
            tabs.forEach(t => t.classList.remove('custom-product-active-link'));
            
            // 2. Add active class to clicked tab
            this.classList.add('custom-product-active-link');

            // 3. Hide all content divs using d-none utility class
            contents.forEach(content => content.classList.add('d-none'));

            // 4. Show the target content div based on the clicked tab's ID
            const targetId = this.getAttribute('id') === 'pre-select-tab' 
                ? 'pre-select-tab-content' 
                : 'own-bundle-tab-content';
            
            const targetContent = document.getElementById(targetId);
            if (targetContent) {
                targetContent.classList.remove('d-none');
            }
        });
    });
});
